<div class="generic-list">
  @if (items && items.length > 0) {
    <table mat-table [dataSource]="dataSource" matSort [matSortActive]="sortActive" [matSortDirection]="sortDirection" (matSortChange)="onMatSortChange($event)" class="mat-elevation-z2">
      @if (enableSelection) {
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef class="select-header">
            <mat-checkbox
              (change)="toggleAllSelection()"
              [checked]="isAllSelected()"
              [indeterminate]="isPartiallySelected()"
              aria-label="Select all rows">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let item" class="select-cell" (click)="$event.stopPropagation()">
            <mat-checkbox
              (change)="toggleSelection(item)"
              [checked]="isSelected(item)"
              aria-label="Select row">
            </mat-checkbox>
          </td>
        </ng-container>
      }

      @for (column of displayedColumns; track column) {
        @if (column !== 'actions' && column !== 'select') {
          <ng-container [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!isSortable(column)" [class.boolean-header]="isBooleanColumn(column)">{{ getColumnDisplayName(column) }}</th>
            <td mat-cell *matCellDef="let item" (click)="onItemClick(item)" [class.boolean-cell]="isBooleanColumn(column)"
                [ngClass]="getCellClasses(item, column)"
                [matTooltip]="getCellTooltip(item, column)"
                [matTooltipDisabled]="!getCellTooltip(item, column)">
              @if (isEditing(item) && isEditableColumn(column)) {
                <mat-form-field appearance="fill" class="edit-field">
                  <input matInput
                         [(ngModel)]="editingValues[column]"
                         (keydown)="onKeyDown($event, item)"
                         (click)="$event.stopPropagation()"
                         #editInput>
                </mat-form-field>
              } @else if (isBooleanColumn(column)) {
                @if (getBooleanValue(item, column)) {
                  <mat-icon class="boolean-check-icon">check</mat-icon>
                }
              } @else if (isDateColumn(column)) {
                {{ getFormattedDate(item, column) }}
              } @else if (isDateTimeColumn(column)) {
                {{ getFormattedDateTime(item, column) }}
              } @else if (isObjectColumn(column)) {
                {{ getObjectName(item, column) }}
              } @else if (isEnumColumn(column)) {
                {{ getEnumValue(item, column) }}
              } @else if (isArrayColumn(column)) {
                <span [matTooltip]="getFullArrayValue(item, column)" matTooltipClass="array-tooltip">
                  {{ getTruncatedArrayValue(item, column) }}
                </span>
              } @else if (isSummaryColumn(column)) {
                <span [matTooltip]="getSummaryTooltip(item, column)" matTooltipClass="array-tooltip">
                  {{ getSummaryDisplay(item, column) }}
                </span>
              } @else if (isListColumn(column)) {
                <ul class="list-column">
                  @for (entry of getListValues(item, column); track entry) {
                    @if (isListClickable(column)) {
                      <li><a class="list-item-link" (click)="onListItemClick(item, column, entry, $event)">{{ getListItemLabel(entry) }}</a></li>
                    } @else {
                      <li>{{ getListItemLabel(entry) }}</li>
                    }
                  }
                </ul>
              } @else if (isTooltipIconColumn(column)) {
                @if (getTooltipIconText(item, column); as tooltip) {
                  <mat-icon class="cell-info-icon" [matTooltip]="tooltip" (click)="$event.stopPropagation()">info_outline</mat-icon>
                }
              } @else if (isBadgeColumn(column)) {
                @if (getBadgeLabel(item, column); as badgeLabel) {
                  <span class="type-badge" [ngClass]="getBadgeClass(item, column)">{{ badgeLabel }}</span>
                }
              } @else {
                {{ item[column] }}
              }
            </td>
          </ng-container>
        }
      }

      @if (enableEdit || enableDelete || enableLink || enableView || enableTransfer || enableMatching || enableAuditLog) {
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let item" class="actions-cell">
            <div class="action-buttons">
              @if (isEditing(item)) {
                <button mat-icon-button
                        (click)="saveEdit(item)"
                        class="save-button"
                        matTooltip="Save"
                        [disabled]="!hasValidEditingValues()">
                  <mat-icon>check</mat-icon>
                </button>
                <button mat-icon-button
                        (click)="cancelEdit()"
                        class="cancel-button"
                        matTooltip="Cancel">
                  <mat-icon>close</mat-icon>
                </button>
              } @else {
                @if (enableAuditLog) {
                  <button mat-icon-button
                          (click)="onAuditLogClick(item, $event)"
                          class="audit-log-button"
                          matTooltip="View audit log">
                    <mat-icon>history</mat-icon>
                  </button>
                }
                @if (enableMatching) {
                  <button mat-button
                          (click)="onMatchClick(item, $event)"
                          class="match-button"
                          [class.active]="getItemState(item) === 'matched'">
                    Match
                  </button>
                  <button mat-button
                          (click)="onRightClick(item, $event)"
                          class="right-button"
                          [class.active]="getItemState(item) === 'right'">
                    Right
                  </button>
                }
                @if (enableTransfer) {
                  <button mat-icon-button
                          (click)="onTransferClick(item, $event)"
                          class="transfer-button"
                          [disabled]="isTransferDisabled(item)"
                          [matTooltip]="isTransferDisabled(item) ? 'Already transferred' : 'Transfer to Companies'">
                    <mat-icon>swap_horiz</mat-icon>
                  </button>
                }
                @if (enableView) {
                  <button mat-icon-button
                          (click)="onViewClick(item, $event)"
                          class="view-button"
                          matTooltip="View">
                    <mat-icon>visibility</mat-icon>
                  </button>
                }
                @if (enableLink) {
                  <button mat-icon-button
                          (click)="onLinkClick(item, $event)"
                          class="link-button"
                          [matTooltip]="linkTooltip"
                          [matTooltipDisabled]="!linkTooltip">
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                }
                @if (enableEdit) {
                  <button mat-icon-button
                          (click)="onEditClick(item, $event)"
                          class="edit-button">
                    <mat-icon>edit</mat-icon>
                  </button>
                }
                @if (enableDelete) {
                  <span [matTooltip]="protectedDeleteTooltip"
                        [matTooltipDisabled]="!isDeleteProtected(item)">
                    <button mat-icon-button
                            (click)="onDeleteClick(item, $event)"
                            class="delete-button"
                            [disabled]="isDeleteProtected(item)">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </span>
                }
              }
            </div>
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.editing]="isEditing(row)" [ngClass]="getRowClasses(row)" [class.has-row-accent]="getRowAccent(row)" [style.--row-accent]="getRowAccent(row)"></tr>
    </table>
    @if (enablePaging) {
    <mat-paginator
      [length]="serverSidePagination ? totalItems : dataSource.data.length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
      (page)="onPageChangeEvent($event)"
      aria-label="Select page">
    </mat-paginator>
    }
  } @else {
    <div class="empty-state">
      {{ emptyMessage }}
    </div>
  }
</div>
